import React, { useRef, useState, useEffect, useCallback } from 'react';
import Navbar from '../../layout/Navbar/Navbar';
import Sidebar from '../../layout/Sidebar/SideBar';
import { Form, Modal } from 'react-bootstrap';
import { ModalApontamento } from './ModalApontamento';
import { Print, CropFree, EditNote, Laptop, FindReplace, AddAPhoto } from '@mui/icons-material';
import JsBarcode from 'jsbarcode';
import { XMLSerializer } from 'xmldom';
import blogFetch from '../../axios/config';
import toast from 'react-hot-toast';
import { TabelaResumoOrdens } from './TabelaResumoOrdens';
import { TabelaConsumoComponentes } from './TabelaConsumoComponentes';
import { TabelaApontametosACV } from './TabelaApontametosACV';
import { ModalApontamentoACV } from './ModalApontamentoACV';
import axios from 'axios';
import { DTO, LossCause, LossOrigin, Origin } from './Types';
import { RESERVED } from '../molds/CardMolds';
import Webcam from "react-webcam";
import { Url } from 'url';
import { TabelInspecos } from './TabelaInspecoes';

export const Apontamento_SAP = () => {
    //#region States
    const [modalImpressao, setModalImpressao] = useState(false);
    const [modalVerificador, setModalVerificador] = useState(false);
    const [modalACV, setModalACV] = useState(false);
    const [modalApontACVModal, setModalApontACVModal] = useState(false);
    const [centroTrabalhoSelect, setCentroTrabalhoSelect] = useState('');
    const [ordem, setOrdem] = useState('');
    const [loteVerificar, setLoteVerificar] = useState('');
    const [loteVerificador, setLoteVerificador] = useState('');
    const [ciclo, setCiclo] = useState('');
    const [tipoApontamentoACV, setTipoApontamentoACV] = useState('');
    const svgRef = useRef<SVGSVGElement | null>(null);
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const [modal, setModal] = useState(false);
    const [lossModal, setLossModal] = useState(false);
    const [photoModal, setPhotoModal] = useState(false);
    const [order, setOrder] = useState<string>("")
    const [appointmentType, setAppointmentType] = useState<string>("")
    const abortControllerRef = useRef<AbortController | null>(null);
    const [orderFound, setOrderFound] = useState<boolean>(false);
    const [dto, setDTO] = useState<DTO>();
    const [origins, setOrigins] = useState<Origin[]>([]);
    const [groupDefects, setGroupDefects] = useState<Origin[]>([]);
    const [defects, setDefects] = useState<Origin[]>([]);
    const [causes, setCauses] = useState<Origin[]>([]);
    const [origin, setOrigin] = useState<LossOrigin>();
    const [defectGroup, setDefectGroup] = useState<string>();
    const [defect, setDefect] = useState<string>();
    const [equipment, setEquipment] = useState<string>();

    const [cause, setCause] = useState<LossCause>();
    const [observations, setObservations] = useState<string>();
    const [destiny, setDestiny] = useState<string>("");
    const [enableAppontmentSubmit, setEnableAppontmentSubmit] = useState<boolean>(false);

    const [photo, setPhoto] = useState<File>();
    const [imageUrl, setImageUrl] = useState<string>("");
    const webcamRef = useRef<Webcam>(null);
    const videoConstraints = {
        width: 800,
        height: 600,
        facingMode: "environment"
    };
    const [atualizarListaACV, setAtualizarListaACV] = useState(0);

    const CentroTrabalho = [
        '01CORTE', '01HIDCOR', '03SERIG', '05EMPOLV', '06CURVAD', '09IOX_E',
        '09IOX_S', '12P_MONT', '13PRE_IB', '14MONTAG', '15EMBOL',
        '16ACV', '18INSFIN', '57ENGENH', '57LABORA'
    ];

    const Destinos = [
        "01CORTE-01VEXTU", "01CORTE-02VP01U", "01CORTE-03VP02U", "01CORTE-32VPMOU", "01CORTE-33VPR01",
        "01CORTE-36VTPAU", "03SERIG-03VP02U", "05EMPOLV-EMPOLVA", "06CURVAD-ENTH", "06CURVAD-SALH", "09IOX_E-ENTIOX",
        "09IOX_E-INSLITE", "09IOX_S-SALIOX2", "13PRE_IB-PREIB33", "14MONTAG-MONTAGE", "15EMBOL-EMBOLSA", "16ACV-EACV",
        "16ACV-SACV", "18INSFIN-INSPFIN"
    ];
    const CentroTrabalhoReprocesso = [
        "01CORTE",
        "01HIDCOR",
        "09IOX_E",
        "09IOX_S",
        "06CURVAD",
        "12P_MONT",
        "13PRE_IB",
        "14MONTAG",
        "15EMBOL",
        "18INSFIN",
        "57LABORA"
    ];

    const CentroTrabalhoRefugo = [
        "09IOX_E",
        "09IOX_S",
        "06CURVAD",
        "12P_MONT",
        "13PRE_IB",
        "14MONTAG",
        "15EMBOL",
        "18INSFIN",
        "57LABORA"
    ];

    const CentroTrabalhoRetrabalho = [
        "18INSFIN"
    ];
    const CentroTrabalhoSemApontamentoPerda = [
        "03SERIG", "05EMPOLV", "16ACV"
    ]


    //#endregion

    //#region UseEffects

    useEffect(() => {
        const fetchOrder = async () => {
            if (order !== "") {
                await getOrder();
            }
        };
        fetchOrder();
    }, [order])

    useEffect(() => {
        if (centroTrabalhoSelect)
            GetOriginBySector(centroTrabalhoSelect);
    }, [centroTrabalhoSelect])

    useEffect(() => {
        if (origin) {
            GetGroupDefectByOrigin(origin.Origem_Cod);
        }
        setDefectGroup(undefined);
        setDefect(undefined);
        setCause(undefined);

    }, [origin])

    useEffect(() => {
        if (defectGroup && origin) {
            GetDefectByGroupDefect(origin.Origem_Cod, defectGroup);
        }
        setDefect(undefined);
        setCause(undefined);
    }, [defectGroup])

    useEffect(() => {
        if (defect && origin && defectGroup) {
            GetCausesByDefect(origin.Origem_Cod, defectGroup, defect);
        }
        setCause(undefined);
    }, [defect])

    useEffect(() => {
        if (cause == undefined)
            setEnableAppontmentSubmit(false);
        else
            setEnableAppontmentSubmit(true);

    }, [cause])

    //#endregion

    //#region Utils
    const resetApontamentoACV = () => {
        setCiclo('');
        setTipoApontamentoACV('');
    };

    const resetLotes = () => {
        setLoteVerificar('');
        setLoteVerificador('');
    };

    const resetOrdem = () => {
        setOrdem('');
    };
    //#endregion

    //#region Handlers
    const handleImpressaoCloseModal = () => {
        resetOrdem();
        setModalImpressao(false);
    };

    const handleModalCloseVerificador = () => {
        resetLotes();
        setModalVerificador(false);
    };

    const handleACVCloseModal = () => {
        setModalACV(false);
    };

    

    const handleCloseACVApontModal = () => {
        resetApontamentoACV();
        setModalApontACVModal(false);
    };

    //#region Handlers
    const handleCloseModal = () => setModal(false);
    const handleShowModal = () => setModal(true);
    const handleImpressaoShowModal = () => setModalImpressao(true);
    const handleModalVerificador = () => setModalVerificador(true);
    const handleACVShowModal = () => setModalACV(true);
    const handleShowACVApontModal = () => setModalApontACVModal(true)

    //#endregion

    //#region Funções

    const GetOriginBySector = async (centroTrabalho: string) => {
        try {
            const { data } = await blogFetch.get(`/CatalogoDefeitos/Origin/${centroTrabalho}`);
            setOrigins(data);
            return data
        } catch (error) {
            console.error(error);
        };
    };

    const ClearData = async () => {
        setDefectGroup(undefined);
        setDefect(undefined);
        setCause(undefined);
        setOrigin(undefined);
        setEquipment(undefined);
        setOrder("");
        setLossModal(false);
        setObservations("");
        setAppointmentType("");
        setDestiny("");
        setOrderFound(false);
    }

    const GetGroupDefectByOrigin = async (origem: string) => {
        try {
            const { data } = await blogFetch.get(
                `/CatalogoDefeitos/GroupDefect?origin=${origem}&sector=${centroTrabalhoSelect}`
            );
            setGroupDefects(data);
            return data
        } catch (error) {
            console.error(error);
        };
    };

    const GetDefectByGroupDefect = async (origem: string, grupoDefeito: string) => {
        try {
            const { data } = await blogFetch.get(
                `/CatalogoDefeitos/Defect?origin=${origem}&sector=${centroTrabalhoSelect}&grupoDefeito=${grupoDefeito}`
            );
            setDefects(data);
            return data
        } catch (error) {
            console.error(error);
        };
    };

    const GetCausesByDefect = async (origem: string, grupoDefeito: string, defeito: string) => {
        try {
            const { data } = await blogFetch.get(
                `/CatalogoDefeitos/Cause?defect=${defeito}&origin=${origem}&sector=${centroTrabalhoSelect}&grupoDefeito=${grupoDefeito}`
            );
            setCauses(data);
            return data
        } catch (error) {
            console.error(error);
        };
    };

    const SubmitAppointment = async () => {
        if (!dto || !origin || !cause || !appointmentType) {
            toast.error("Preencha todos os campos obrigatórios");
            return;
        }

        if (centroTrabalhoSelect == "06CURVAD" && equipment == undefined) {
            toast.error("Selecione o equipamento!");
            return;
        }

        if ((appointmentType == "RETRABALHO" || appointmentType == "REPROCESSO") && !destiny) {
            toast.error("Preencha o campo de destino!");
            return;
        }

        try {

            const formData = {
                Centro_Trabalho: centroTrabalhoSelect,
                Nro_Matricula: user.user_SAPMatricula,
                Ordem_Fabricacao: dto.Ordem_Serial,
                Operacao: "1000",
                Tipo_Apontamento: appointmentType,
                Defeito_Grupo: defectGroup,
                Defeito_Cod: defect,
                Origem_Grupo: origin.Origem_Cod,
                Origem_Cod: defect,
                Causa_Grupo: cause.Causa_Grupo,
                Causa_Cod: cause.Causa_Cod,
                Observacao: observations,
                Equipamento: equipment,
                Chave_Modelo: dto?.ADICIONAL_2,
                Integration_Status: "NA FILA",
                Destino: destiny,
                _ts_Creat: new Date()
            };
            if (photo) {
                const submitPhotoResponse = await SubmitPhoto();
                if (submitPhotoResponse == false) {
                    return;
                }
            }

            await blogFetch.post('Loss/create', formData);
            toast.success("Apontamento realizado com sucesso!");
            setLossModal(false);
            setOrder("");
            setAppointmentType("");
            ClearData();

        } catch (error) {
            console.error(error);
            toast.error("Erro ao realizar apontamento");
            return;
        }
        finally {
            // ClearData();
            // setLossModal(false);
        }
    };

    const SubmitPhoto = async () => {
        if (!imageUrl) {
            toast.error("É preciso tirar a foto!");
            return;
        }
        try {

            const formData = new FormData();

            if (photo) {
                formData.append('entryFile', photo);
                formData.append('pathName', order);
            }
            else
                return;
            await blogFetch.post('Loss/create/photo', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            toast.success("Foto guardada com sucesso!");
            setPhotoModal(false);

        } catch (error) {
            console.error(error);
            toast.error("Erro ao salvar a foto");
            return false;
        }
        finally {
            setPhotoModal(false);
            setPhoto(undefined);
            setImageUrl("");
        }
    };

    const getOrder = async () => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        const controller = new AbortController();
        abortControllerRef.current = controller;

        try {
            const response = await blogFetch.get<DTO>(`Loss/get/${order}`, {
                signal: controller.signal,
            });
            setDTO(response.data);

            setOrderFound(true);

        } catch (error: any) {
            setOrderFound(false);
            if (axios.isAxiosError(error) && (error.code === "ERR_CANCELED" || error.name === "CanceledError")) {
                return;
            }
            if (axios.isAxiosError(error) && error.response?.status === 404) {
                toast.error("Ordem não encontrada!");
                return;
            }
            console.error("Outro erro:", error);
            toast.error("Erro ao buscar ordem.");
        }
    };

    const imprimirCodigoBarras = async () => {
        if (!ordem.trim()) {
            toast.error('Digite o número da ordem antes de imprimir.');
            return;
        }

        try {
            const response = await blogFetch.get<string>(`ISAGA_InspecaoFinal/getLotePorOrdem/${ordem}`);
            let lote = `I${response.data}`;

            JsBarcode(svgRef.current, lote, {
                format: 'CODE128',
                width: 3,
                height: 90,
                displayValue: false
            });

            if (!svgRef.current) return;

            const serializer = new XMLSerializer();
            const svgString = serializer.serializeToString(svgRef.current);

            const janela = window.open('', '_blank');
            if (janela) {
                janela.document.write(`
          <html>
            <head>
              <title>Etiqueta</title>
              <style>
                @page { size: 10cm 3cm; margin: 0; }
                body { display: flex; justify-content: center; align-items: center; margin: 0; }
                svg { max-width: 100%; height: 100%; }
              </style>
            </head>
            <body>${svgString}<script>window.onload=()=>{window.print();window.close();}</script></body>
          </html>
        `);
                janela.document.close();
            }

            const novaInspecao = {
                inspecao_lote: lote,
                data_criado: new Date(),
                criadoPor: user.user_UserName,
                inpecao_status: 'Verificar',
            };

            await blogFetch.post('ISAGA_InspecaoFinal/CriarInspecaoFinal', novaInspecao);
            toast.success('Inspeção criada com sucesso!');
        } catch (error) {
            console.error(error);
            toast.error('Erro ao buscar o lote para esta ordem.');
        } finally {
            handleImpressaoCloseModal();
        }
    };

    const verificarCodigo = async () => {
        if (!loteVerificar.trim() || !loteVerificador.trim()) {
            toast.error('Preencha ambos os campos.');
            return;
        }

        if (loteVerificar.replace('I', '') !== loteVerificador) {
            toast.error('Os lotes não coincidem.');
            return;
        }

        try {
            await blogFetch.put(
                `ISAGA_InspecaoFinal/atualizarInspecao/${loteVerificar}`,
                user.user_UserName
            );
            toast.success('Lote verificado com sucesso!');
            handleModalCloseVerificador();
        } catch (error) {
            console.error(error);
            toast.error('Erro ao verificar o lote.');
        }
    };

    const handleApontamentoACV = async () => {
        if (!ciclo.trim() || !tipoApontamentoACV.trim()) {
            toast.error('Preencha todos os campos antes de salvar.');
            return;
        }

        try {
            await blogFetch.put('ApontamentoAutoClave/apontarCiclo', {
                ciclo,
                tipoApontamento: tipoApontamentoACV,
                user: user.user_UserName
            });

            toast.success('Apontamento realizado com sucesso!');
            setAtualizarListaACV(prev => prev + 1);
            handleCloseACVApontModal();
        } catch (error) {
            console.error(error);
            toast.error('Erro ao apontar ciclo.');
        }
    };

    function dataURLtoFile(dataurl: any, filename: string) {
        const arr = dataurl.split(",");
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[arr.length - 1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    const capturePhoto = useCallback(async () => {
        try {
            const imageSrc = webcamRef.current?.getScreenshot();
            if (!imageSrc) {
                toast.error("Não foi possível capturar a foto");
                return;
            }
            setImageUrl(imageSrc);
            const orderText = `Ordem_${order}`;
            setPhoto(dataURLtoFile(imageSrc, orderText))

        } catch {
            toast.error("Câmera não carregada... Aguarde", {
                duration: 4000,
            });
        }
        finally {
            setPhotoModal(false);
        }

    }, [order, webcamRef]);
    //#endregion

    //#region Render
    return (
        <>
            <Navbar />
            <Sidebar />
            <div className="app_body p-0 d-flex flex-column">
                <div className="container-fluid flex-grow-1 d-flex flex-column">

                    <div className="my-4 d-flex justify-content-center align-items-center gap-3 flex-wrap">
                        <h1 className="h4 mb-0 text-gray-800">
                            Centro de Trabalho:
                        </h1>

                        <select
                            className="form-select form-select-sm w-auto shadow-sm rounded"
                            value={centroTrabalhoSelect}
                            onChange={(e) => setCentroTrabalhoSelect(e.target.value)}
                        >
                            <option value="">Escolha um Centro</option>
                            {CentroTrabalho.map((centro) => (
                                <option key={centro} value={centro}>
                                    {centro}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Menu */}
                    <div className="card mb-2">
                        <div className="card-header">
                            <h2 className="card-title h6 mb-0">Menu</h2>
                        </div>
                        <div className="card-body p-2 d-flex gap-2">

                            {centroTrabalhoSelect === '18INSFIN' && (
                                <>
                                    <button
                                        className="btn btn-success btn-sm d-flex flex-column align-items-center"
                                        onClick={() => setModalImpressao(true)}
                                    >
                                        <Print fontSize="small" />
                                        <span className="small">Imprimir</span>
                                    </button>

                                    <button
                                        className="btn btn-info btn-sm d-flex flex-column align-items-center"
                                        onClick={() => setModalVerificador(true)}
                                    >
                                        <CropFree fontSize="small" />
                                        <span className="small">Verificar</span>
                                    </button>
                                </>

                            )}

                            {centroTrabalhoSelect === '16ACV' && (
                                <>
                                    <button
                                        className="btn btn-success btn-sm d-flex flex-column align-items-center"
                                        onClick={() => setModalACV(true)}
                                    >
                                        <EditNote fontSize="small" />
                                        <span className="small">Criar Ciclo</span>
                                    </button>
                                    {/* <button
                                        className="btn btn-primary btn-sm d-flex flex-column align-items-center"
                                        onClick={() => setModalApontACVModal(true)}
                                    >
                                        <Laptop fontSize="small" />
                                        <span className="small">Apontar Ciclo</span>
                                    </button> */}
                                </>

                            )}

                            {centroTrabalhoSelect && !CentroTrabalhoSemApontamentoPerda.includes(centroTrabalhoSelect) && (
                                <button
                                    className='btn btn-danger btn-sm d-flex flex-column align-items-center rounded-3 shadow-sm'
                                    onClick={() => setLossModal(true)}
                                >
                                    <FindReplace fontSize="small" />
                                    <span className="small">Perdas</span>
                                </button>
                            )}
                        </div>
                    </div>

                    {/* Tabelas dinâmicas */}
                    {centroTrabalhoSelect === '14MONTAG' && (
                        <div className="d-flex flex-column overflow-y-auto">
                            <TabelaResumoOrdens />
                            <TabelaConsumoComponentes />
                        </div>
                    )}

                    {centroTrabalhoSelect === '16ACV' && (
                        <div className="d-flex flex-column overflow-y-auto">
                            <TabelaApontametosACV atualizarSignal={atualizarListaACV} />
                        </div>
                    )}

                    {centroTrabalhoSelect === '18INSFIN' && (
                        <div className="d-flex flex-column overflow-y-auto">
                            <TabelInspecos />
                        </div>
                    )}
                </div>

                {/* ---------- MODAIS ---------- */}

                {/* modal de foto */}
                <Modal backdrop="static" keyboard={false} centered show={photoModal} onHide={(() => { setPhotoModal(false) })} size="xl">
                    <Modal.Header closeButton>
                        <Modal.Title>Tirar foto</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="d-flex justify-content-center align-items-center" style={{ minHeight: "400px" }}>
                        <div style={{ width: "100%", maxWidth: "500px" }}>
                            {imageUrl === "" ? (
                                <div className="d-flex justify-content-center">
                                    <Webcam
                                        ref={webcamRef}
                                        audio={false}
                                        screenshotFormat="image/jpeg"
                                        videoConstraints={videoConstraints}
                                        style={{
                                            width: "100%",
                                            maxWidth: "500px",
                                            height: "auto",
                                            borderRadius: "8px",
                                            aspectRatio: "4/3"
                                        }}
                                        mirrored={false}
                                    />
                                </div>
                            ) : (
                                <div className="d-flex justify-content-center">
                                    <img
                                        src={imageUrl}
                                        alt="captured"
                                        style={{
                                            width: "100%",
                                            maxWidth: "500px",
                                            height: "auto",
                                            borderRadius: "8px",
                                            aspectRatio: "4/3",
                                            objectFit: "cover"
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-secondary" onClick={(() => {
                            setImageUrl("");
                        })}>Limpar</button>
                        <button className="btn btn-secondary" onClick={(() => {
                            setPhotoModal(false);
                        })}>Fechar</button>
                        <button className="btn btn-success" onClick={(() => {
                            // SubmitAppointment();
                            capturePhoto();
                        })}>Tirar foto</button>
                    </Modal.Footer>
                </Modal>

                {/* modal de refugo */}
                <Modal backdrop="static" keyboard={false} centered show={lossModal} onHide={(() => { ClearData() })} size="xl">
                    <Modal.Header closeButton>
                        <Modal.Title>Apontar peça</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <label className="form-label fw-bold">Insira a ordem da peça:</label>
                        <input
                            type="text"
                            className="form-control form-control-sm mb-3"
                            value={order}
                            onChange={(x) => setOrder(x.target.value)}
                        />
                        {orderFound && (
                            <>
                                <div className="btn-group" role="group" aria-label="Tipo de apontamento">

                                    {CentroTrabalhoReprocesso.includes(centroTrabalhoSelect) &&
                                        (<>
                                            <input
                                                type="radio"
                                                className="btn-check"
                                                name="appointmentType"
                                                id="appt2"
                                                autoComplete="off"
                                                value="REPROCESSO"
                                                checked={appointmentType === "REPROCESSO"}
                                                onChange={(e) => setAppointmentType(e.target.value)}
                                            />
                                            <label className="btn btn-outline-secondary" htmlFor="appt2">Reprocesso</label>
                                        </>)}

                                    {CentroTrabalhoRetrabalho.includes(centroTrabalhoSelect) &&
                                        (<>
                                            <input
                                                type="radio"
                                                className="btn-check"
                                                name="appointmentType"
                                                id="appt3"
                                                autoComplete="off"
                                                value="RETRABALHO"
                                                checked={appointmentType === "RETRABALHO"}
                                                onChange={(e) => setAppointmentType(e.target.value)}
                                            />
                                            <label className="btn btn-outline-secondary" htmlFor="appt3">Retrabalho</label>
                                        </>)}

                                    {CentroTrabalhoRefugo.includes(centroTrabalhoSelect) &&
                                        (<>
                                            <input
                                                type="radio"
                                                className="btn-check"
                                                name="appointmentType"
                                                id="appt1"
                                                autoComplete="off"
                                                value="REFUGO"
                                                checked={appointmentType === "REFUGO"}
                                                onChange={(e) => setAppointmentType(e.target.value)}
                                            />
                                            <label className="btn btn-outline-secondary" htmlFor="appt1">Refugo</label>
                                        </>)}

                                </div>

                                {dto?.Ordem_SetAtual != centroTrabalhoSelect && (
                                    <>
                                        <div className='mt-2'>
                                            <p className='text-danger'>A ordem digitada não está no mesmo centro de trabalho que o selecionado!</p>
                                        </div>
                                    </>)}

                                <div >
                                    {appointmentType &&
                                        (<>

                                            {appointmentType === "REFUGO" &&
                                                (<>
                                                    <div className="mb-3">
                                                        <label className="form-label fw-bold">Adicionar Foto</label>
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-secondary w-100 d-flex align-items-center justify-content-center gap-2"
                                                            onClick={() => {
                                                                setPhotoModal(true);
                                                            }}
                                                        >
                                                            <AddAPhoto />
                                                            <span>Tirar Foto</span>
                                                        </button>

                                                        {imageUrl && (
                                                            <div className="d-flex justify-content-center mt-2">
                                                                <img
                                                                    src={imageUrl}
                                                                    alt="captured"
                                                                    style={{
                                                                        width: "100%",
                                                                        maxWidth: "300px",
                                                                        height: "auto",
                                                                        borderRadius: "8px",
                                                                        aspectRatio: "4/3",
                                                                        objectFit: "cover"
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </>
                                                )
                                            }

                                            <label className="form-label fw-bold">Ordem</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm mb-3"
                                                value={dto?.Ordem_Serial}
                                                disabled
                                            />

                                            <label className="form-label fw-bold">Chave modelo</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm mb-3"
                                                value={dto?.ADICIONAL_2}
                                                disabled
                                            />

                                            <label className="form-label fw-bold">Origem:</label>
                                            <select
                                                value={origin?.Origem_Cod || ''}
                                                onChange={(e) => {
                                                    const selected = origins.find(apt => apt.cod_Origem === e.target.value)
                                                    if (selected) {
                                                        setOrigin({
                                                            Origem_Cod: selected.cod_Origem,
                                                            Origem_Grupo: selected.cod_Grupo_Defeitos,
                                                        })
                                                    } else {
                                                        setOrigin(undefined)
                                                    }
                                                }}
                                                className="form-select form-control form-control-sm mb-3"
                                            >
                                                <option value="">Selecione...</option>
                                                {origins.map((option, index) => (
                                                    <option key={index} value={option.cod_Origem}>
                                                        {`${option.cod_Origem} (${option.origem_Setor})`}
                                                    </option>
                                                ))}
                                            </select>

                                            <label className="form-label fw-bold">Grupo defeito:</label>
                                            <select
                                                value={defectGroup || ''}
                                                disabled={origin ? false : true}
                                                onChange={(e) => setDefectGroup(e.target.value)}
                                                className="form-select form-control form-control-sm mb-3"
                                            >
                                                <option value="">Selecione...</option>
                                                {groupDefects.map((option, index) => (
                                                    <option key={index} value={option.cod_Grupo_Defeitos}>
                                                        {`${option.cod_Grupo_Defeitos} (${option.grupo_Defeito})`}
                                                    </option>
                                                ))}
                                            </select>

                                            <label className="form-label fw-bold">Defeito:</label>
                                            <select
                                                value={defect || ''}
                                                disabled={origin && defectGroup ? false : true}
                                                onChange={(e) => setDefect(e.target.value)}
                                                className="form-select form-control form-control-sm mb-3"
                                            >
                                                <option value="">Selecione...</option>
                                                {defects.map((option, index) => (
                                                    <option key={index} value={option.cod_Defeito}>
                                                        {`${option.cod_Defeito} (${option.defeito})`}
                                                    </option>
                                                ))}
                                            </select>

                                            <label className="form-label fw-bold">Causa:</label>
                                            <select
                                                value={cause?.Causa_Cod || ''}
                                                disabled={origin && defectGroup && defect ? false : true}

                                                onChange={(e) => {
                                                    const selected = causes.find(c => c.cod_Causa === e.target.value)
                                                    if (selected) {
                                                        setCause({
                                                            Causa_Cod: selected.cod_Causa,
                                                            Causa_Grupo: selected.cod_Origem,
                                                        })
                                                    } else {
                                                        setCause(undefined)
                                                    }
                                                }}
                                                className="form-select form-control form-control-sm mb-3"
                                            >
                                                <option value="">Selecione...</option>
                                                {causes.map((option, index) => (
                                                    <option key={index} value={option.cod_Causa}>
                                                        {`${option.causa} (${option.cod_Causa})`}
                                                    </option>
                                                ))}
                                            </select>

                                            {centroTrabalhoSelect == "06CURVAD" &&
                                                (
                                                    <>
                                                        <label className="form-label fw-bold">Equipamento:</label>
                                                        <select
                                                            value={equipment || ''}
                                                            // disabled={origin && defectGroup ? false : true}
                                                            onChange={(e) => setEquipment(e.target.value)}
                                                            className="form-select form-control form-control-sm mb-3"
                                                        >
                                                            <option value="">Selecione...</option>
                                                            <option value="21-HCV01">FORNO CRISMACH (21-HCV01)</option>
                                                            <option value="21-HCV02">FORNO H GLASSROBOT (21-HCV02)</option>
                                                            <option value="21-HCV03">FORNO HBT (21-HCV03)</option>
                                                            <option value="21-HCV05">FORNO TAM GLASS (21-HCV05)</option>
                                                            <option value="21-HCV06">FORNO SGLASS (21-HCV06)</option>
                                                            <option value="21-HCV07">FORNO G SGLASS (21-HCV07)</option>
                                                        </select>
                                                    </>
                                                )}


                                            {(appointmentType == "RETRABALHO" || appointmentType == "REPROCESSO") && (
                                                <>
                                                    <label className="form-label fw-bold">Destino:</label>
                                                    <select
                                                        value={destiny || ''}
                                                        onChange={(e) => setDestiny(e.target.value)}
                                                        className="form-select form-control form-control-sm mb-3"
                                                    >
                                                        <option value="">Selecione o destino...</option>
                                                        {Destinos.map((d) => (
                                                            <option key={d} value={d}>{d}</option>
                                                        ))}
                                                    </select>
                                                </>)}

                                            <label className="form-label fw-bold">Comentarios</label>
                                            <textarea
                                                value={observations}
                                                onChange={(e) => setObservations(e.target.value)}
                                                className="form-control"
                                                placeholder="Leave a comment here"
                                            />
                                        </>)}
                                </div>

                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-secondary" onClick={(() => { ClearData() })}>Fechar</button>
                        <button disabled={!enableAppontmentSubmit} className="btn btn-success" onClick={(() => {
                            SubmitAppointment();
                        })}>Enviar</button>
                    </Modal.Footer>
                </Modal>

                {/* Modal Impressão */}
                <Modal centered show={modalImpressao} onHide={handleImpressaoCloseModal} size="lg">
                    <Modal.Header closeButton><Modal.Title>Imprimir código</Modal.Title></Modal.Header>
                    <Modal.Body>
                        <input
                            type="text"
                            className="form-control form-control-sm mb-3"
                            placeholder="Digite o número da ordem"
                            value={ordem}
                            onChange={(e) => setOrdem(e.target.value)}
                        />
                        <svg ref={svgRef} style={{ display: 'none' }}></svg>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-secondary" onClick={handleImpressaoCloseModal}>Fechar</button>
                        <a className="btn btn-success" href={`sagaprintserver:BR-BufferFornos;SAGA_User;${ordem}`}>Imprimir</a>
                        {/* <button className="btn btn-success" onClick={imprimirCodigoBarras}>Imprimir</button> */}
                    </Modal.Footer>
                </Modal>

                {/* Modal Verificador */}
                <Modal centered show={modalVerificador} onHide={handleModalCloseVerificador}>
                    <Modal.Header closeButton><Modal.Title>Verificar Peça</Modal.Title></Modal.Header>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>Código de barras:</Form.Label>
                            <Form.Control
                                type="text"
                                value={loteVerificar}
                                onChange={(e) => setLoteVerificar(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Confirmar código:</Form.Label>
                            <Form.Control
                                type="text"
                                value={loteVerificador}
                                onChange={(e) => setLoteVerificador(e.target.value)}
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-secondary" onClick={handleModalCloseVerificador}>Fechar</button>
                        <button className="btn btn-success" onClick={verificarCodigo}>Enviar</button>
                    </Modal.Footer>
                </Modal>

                {/* Modal Criação Ciclo */}
                <Modal centered show={modalACV} onHide={handleACVCloseModal} size="xl">
                    <Modal.Header closeButton><Modal.Title>Criação de Ciclo</Modal.Title></Modal.Header>
                    <Modal.Body>
                        <ModalApontamentoACV
                            onCancel={handleACVCloseModal}
                            onSubmit={async (dados) => {
                                try {
                                    await blogFetch.post('ApontamentoAutoClave/criarCiclo', dados);
                                    toast.success('Ciclo criado com sucesso!');
                                    setAtualizarListaACV(prev => prev + 1);
                                    handleACVCloseModal();
                                } catch (error) {
                                    toast.error('Erro ao criar ciclo.');
                                }
                            }}
                        />
                    </Modal.Body>
                </Modal>

                {/* Modal Apontamento ACV */}
                <Modal centered show={modalApontACVModal} onHide={handleCloseACVApontModal}>
                    <Modal.Header closeButton><Modal.Title>Apontar Ciclo</Modal.Title></Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>Número do Ciclo</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={ciclo}
                                    onChange={(e) => setCiclo(e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Tipo de Apontamento</Form.Label>
                                <Form.Select
                                    value={tipoApontamentoACV}
                                    onChange={(e) => setTipoApontamentoACV(e.target.value)}
                                >
                                    <option value="">Escolha o tipo</option>
                                    <option value="Entrada">Entrada</option>
                                    <option value="Saida">Saída</option>
                                </Form.Select>
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-secondary" onClick={handleCloseACVApontModal}>Fechar</button>
                        <button className="btn btn-success" onClick={handleApontamentoACV}>Salvar</button>
                    </Modal.Footer>
                </Modal>
            </div>
        </>
    );
};
